import {
  BIRDVIEW_ATTENTION_DEFAULT_AGE,
  BIRDVIEW_ATTENTION_GROUPS,
} from '../../DashboardBirdview.constants.attention'
import { useBirdviewRequestLoaders } from '../useBirdviewRequestLoaders'

import {
  getBirdviewAttentionGroupFilters,
  toBirdviewAttentionSection,
} from './useBirdviewAttentionLoaders.utils'

export function useBirdviewAttentionLoaders() {
  const { getRequestsSection } = useBirdviewRequestLoaders()

  async function loadAttentionGroup({ age, group, scope, userId }) {
    return getRequestsSection(
      getBirdviewAttentionGroupFilters({ age, group, scope, userId })
    )
  }

  // The backend has no grouped endpoint, so every group is its own query.
  async function getAttentionSection({ scope, userId }) {
    const groups = await Promise.all(
      BIRDVIEW_ATTENTION_GROUPS.map(group =>
        loadAttentionGroup({
          age: BIRDVIEW_ATTENTION_DEFAULT_AGE,
          group: group.key,
          scope,
          userId,
        })
      )
    )

    return toBirdviewAttentionSection(groups)
  }

  return { getAttentionSection, loadAttentionGroup }
}
